<template>
  <!-- Site wrapper -->
  <div class="wrapper">
    <cabecalho tituloPagina="Escritórios" />
    <menuLateral />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6"></div>
          </div>
        </div>
        <!-- /.container-fluid -->
      </section>
      <!-- Main content -->
      <section class="content">
        <!-- Default box -->
        <div class="row m-auto">
          <div class="col-12">
            <div class="card border-1">
              <div class="card-body card-fix-right mt-3">
                <div class="row m-auto">
                  <div class="col-12">
                    <div
                      v-if="flagsDeControle.carregandoDados.status"
                      class="d-flex align-items-center"
                    >
                      <span class="avisoDanger">{{
                        flagsDeControle.carregandoDados.mensagem
                      }}</span>
                      <b-spinner class="ml-2" variant="danger"></b-spinner>
                    </div>
                    <b-alert
                      v-model="flagsDeControle.avisoDeErroNoFormulario.exibir"
                      variant="danger"
                      fade
                      dismissible
                    >
                      <span class="avisoDangerAlerta">{{
                        flagsDeControle.avisoDeErroNoFormulario.mensagem
                      }}</span>
                    </b-alert>

                    <Informacoes :buscarInformacoesDoCnpj="buscarInformacoesDoCnpj" :desabilitarCampos="desabilitarCampos" :enderecoLogotipo="formulario.informacoes.endereco_logotipo"/>
                    <hr>
                    <AbaEndereco v-model="formulario.endereco"/>
                    <hr>
                    <Contato :desabilitarCampos="desabilitarCampos" />

                    <div
                      v-if="flagsDeControle.manipulandoDados.status"
                      class="d-flex align-items-center"
                    >
                      <span class="avisoDanger">{{
                        flagsDeControle.manipulandoDados.mensagem
                      }}</span>
                      <b-spinner class="ml-2" variant="danger"></b-spinner>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-end px-5" role="group">
                  <div class="col-auto">
                      <button
                      class="btn btn-md btn-azul-outline-cancelar-2"
                      :disabled="desabilitarCampos"
                      @click="voltar()"
                      >Cancelar</button
                    >
                  </div>

                  <div class="col-auto">
                    <button
                      class="btn btn-md btn-azul"
                      :disabled="desabilitarCampos"
                      @click="salvarRegistro()"
                      >Salvar</button
                    >
                  </div>
                </div>
              </div>
              <!-- ./ card-body ends-->
            </div>
          </div>
        </div>

        <!-- ./ card ends-->
      </section>
      <!-- ./ content -->
    </div>
    <!-- /.content-wrapper -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import EdicaoEscritorioUsuario from './js/edicao-escritorio-usuario'
export default EdicaoEscritorioUsuario
</script>

<style scoped>
@import "./scss/edicao-escritorio.scss";
</style>
